import script from "./LiveBoardView.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveBoardView.vue?vue&type=script&setup=true&lang=js"

import "./LiveBoardView.vue?vue&type=style&index=0&id=fc5fd6c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc5fd6c4"]])

export default __exports__